import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { UserPayment } from '../../../../../../../api/types/students/payment-services/user-payments/user-payment-service-with-price-list';
import { UserSummaryType } from '../../../../../../../api/types/user/user-summary.type';
import { processRefund } from '../operations/process-refund-operation';

export interface RefundDialogProps {
  visible: boolean;
  payment: UserPayment;
  user: UserSummaryType;
  onClose: () => void;
}

export const RefundDialog: React.FC<RefundDialogProps> = ({
  visible,
  payment,
  user,
  onClose,
}) => {
  const [refundAmount, setRefundAmount] = useState<number>(0);
  const [loading, setLoading] = useState(false);

  const maxRefund = payment.paymentAmount;
  const minRefund = 0;

  const handleApprove = async () => {
    if (
      refundAmount === 0 ||
      refundAmount > maxRefund ||
      refundAmount < minRefund
    ) {
      return;
    }

    await processRefund(
      payment.userAllocationId,
      user.id,
      payment.id,
      payment.itemId,
      refundAmount,
      setLoading,
    );

    onClose();
  };

  const handleCancel = () => {
    setRefundAmount(0);
    onClose();
  };

  return (
    <Dialog
      visible={visible}
      style={{ width: '450px' }}
      header="החזר תשלום"
      modal
      closable={false}
      onHide={onClose}
    >
      <div style={{ padding: '1rem 0' }}>
        <div style={{ marginBottom: '1rem' }}>
          <p style={{ color: '#6B7280', marginBottom: '0.5rem' }}>
            סכום התשלום המקורי: <strong>₪{payment.paymentAmount}</strong>
          </p>
          <p style={{ color: '#6B7280', marginBottom: '1rem' }}>
            ניתן להחזיר עד ₪{payment.paymentAmount} (הזן מספר בין {minRefund} ל-
            {maxRefund})
          </p>
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label
            htmlFor="refundAmount"
            style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: 'bold',
              color: '#374151',
            }}
          >
            סכום להחזרה:
          </label>
          <InputNumber
            id="refundAmount"
            value={refundAmount}
            onChange={(e) => {
              setRefundAmount(e.value || 0);
            }}
            mode="currency"
            currency="ILS"
            locale="he-IL"
            min={minRefund}
            max={maxRefund}
            placeholder="הזן סכום להחזרה"
            style={{ width: '100%' }}
            disabled={loading}
          />
          {(refundAmount > maxRefund || refundAmount < minRefund) && (
            <small
              style={{
                color: '#EF4444',
                marginTop: '0.25rem',
                display: 'block',
              }}
            >
              הסכום חייב להיות בין {minRefund} ל-{maxRefund}
            </small>
          )}
        </div>

        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
          }}
        >
          <Button
            label="ביטול"
            icon="pi pi-times"
            className="p-button-text"
            onClick={handleCancel}
            disabled={loading}
          />
          <Button
            label={loading ? 'מעבד...' : 'אשר החזרה'}
            icon={loading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
            className="p-button-primary"
            onClick={handleApprove}
            disabled={
              loading ||
              refundAmount === 0 ||
              refundAmount > maxRefund ||
              refundAmount < minRefund
            }
            loading={loading}
          />
        </div>
      </div>
    </Dialog>
  );
};
